import React, { useCallback } from 'react';
import { rem, SettingsItemCard } from 'design-system';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import { StyleSheet, View } from 'react-native';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { IconDocument } from 'design-system/icons';
import { useAppSelector } from 'store/hooks';
import Status from 'design-system/Status';
import { IconClipboard } from 'design-system/icons/IconClipboard';
import { formatDateForItem } from 'utils';
import useRequiredBenefitCallback from 'features/premium/hooks/useRequiredBenefitCallback';
import { selectCreditScoreDate, selectCreditScoreFactors, selectIsCreditScoreAvailable, selectIsCreditScoreReportAvailable, } from '../selectors';
import { isPositiveFactor } from '../utils';
const CreditFactorStatusIndicator = () => {
    const colors = useColors();
    const impactingFactorsCount = useAppSelector(selectCreditScoreFactors).filter((factor) => !isPositiveFactor(factor.factorColor)).length;
    return (<View>
      <Status activeText="Doing great" inactiveText={`${impactingFactorsCount} impacting`} active={!impactingFactorsCount} inActiveColor={colors.text.statusInformational}/>
    </View>);
};
const CreditScoreTileSection = () => {
    const navigation = useMainStackNavigation();
    const onPressCreditHealth = useCallback(() => navigation.navigate('CreditScoreEnhancedCreditFactors'), [navigation]);
    const onPressCreditReport = useRequiredBenefitCallback(useCallback(() => navigation.navigate('CreditReportAccountsScreen'), [navigation]), 'creditScoreReports');
    const creditScoreDate = useAppSelector(selectCreditScoreDate);
    const shouldShow = useAppSelector(selectIsCreditScoreAvailable);
    const hasCreditFactors = useAppSelector(selectCreditScoreFactors).length;
    const isCreditReportAvailable = useAppSelector(selectIsCreditScoreReportAvailable);
    if (!shouldShow || !hasCreditFactors)
        return null;
    let creditReportDescription = null;
    if (!isCreditReportAvailable) {
        creditReportDescription = (<Text Text-14 Primary>
        COMING SOON
      </Text>);
    }
    else if (creditScoreDate) {
        creditReportDescription = (<Text TextThin-14 Secondary>
        {formatDateForItem(creditScoreDate)}
      </Text>);
    }
    return (<View style={styles.container}>
      <SettingsItemCard icon={<IconClipboard gradientKey="peach"/>} title={'Credit health'} description={<CreditFactorStatusIndicator />} onPress={onPressCreditHealth} compactText/>
      <SettingsItemCard icon={<IconDocument alt2 gradientKey="darkPurple"/>} title={'Credit report'} description={creditReportDescription} onPress={isCreditReportAvailable ? onPressCreditReport : undefined} compactText/>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        gap: rem(16),
        paddingHorizontal: rem(16),
        flexDirection: 'row',
        marginBottom: rem(24),
    },
});
export default CreditScoreTileSection;
